export default "__VITE_ASSET__$N$dthy0__"